import { useMemo } from 'react';
import { HabitSchedule } from 'shared/types/habit-schedule';
import { Timestamp } from 'shared/types/timestamp';
import { getActiveSchedule } from 'shared/utils/get-active-schedule';

export const useActiveSchedule = (
  schedules: HabitSchedule[] | undefined | null,
  today: Timestamp,
) => useMemo(() => getActiveSchedule(schedules, today), [schedules, today]);
